module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._l((_vm.missionSlotGroups), function(missionSlotGroup) {
    return _c('mission-slotlist-group', {
      key: missionSlotGroup.uid,
      attrs: {
        "missionSlotGroup": missionSlotGroup
      }
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [(_vm.isMissionEditor && !_vm.hasMissionEnded) ? _c('b-btn', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.missionSlotGroupCreateModal",
      modifiers: {
        "missionSlotGroupCreateModal": true
      }
    }],
    attrs: {
      "variant": "success"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.create.mission.slotGroup')) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.isMissionEditor && !_vm.hasMissionEnded) ? _c('b-btn', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.missionApplySlotTemplateModal",
      modifiers: {
        "missionApplySlotTemplateModal": true
      }
    }],
    attrs: {
      "variant": "success"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-text-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.apply.mission.slotGroup')) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('b-btn', {
    on: {
      "click": _vm.refreshMissionSlotlist
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.refresh')) + "\n    ")])], 1), _vm._v(" "), (_vm.isMissionEditor && !_vm.hasMissionEnded) ? _c('div', [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "small text-muted text-center",
    domProps: {
      "innerHTML": _vm._s(_vm.anyMissionSlotSelected ? _vm.$tc('mission.slot.selection.actions', _vm.missionSlotSelectionCount, {
        count: _vm.missionSlotSelectionCount
      }) : _vm.$t('mission.slot.selection.hint'))
    }
  }), _vm._v(" "), (_vm.anyMissionSlotSelected) ? _c('br') : _vm._e(), _vm._v(" "), (_vm.anyMissionSlotSelected) ? _c('div', {
    staticClass: "text-center"
  }, [_c('b-btn', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.missionSlotSelectionEditModal",
      modifiers: {
        "missionSlotSelectionEditModal": true
      }
    }],
    attrs: {
      "variant": "primary"
    }
  }, [_c('i', {
    staticClass: "fa fa-edit",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.edit.mission.slot.selection')) + "\n      ")]), _vm._v(" "), _c('click-confirm', {
    attrs: {
      "yes-icon": "fa fa-close",
      "yes-class": "btn btn-warning",
      "button-size": "sm",
      "messages": {
        title: _vm.$t('mission.slot.confirm.unassign.selection'),
        yes: _vm.$t('button.confirm'),
        no: _vm.$t('button.cancel')
      }
    }
  }, [_c('b-btn', {
    attrs: {
      "variant": "warning"
    },
    on: {
      "click": _vm.unassignSelectedMissionSlots
    }
  }, [_c('i', {
    staticClass: "fa fa-close",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.unassign.mission.slot.selection')) + "\n        ")])], 1), _vm._v(" "), _c('click-confirm', {
    attrs: {
      "yes-icon": "fa fa-trash",
      "yes-class": "btn btn-danger",
      "button-size": "sm",
      "messages": {
        title: _vm.$t('mission.slot.confirm.delete.selection'),
        yes: _vm.$t('button.confirm'),
        no: _vm.$t('button.cancel')
      }
    }
  }, [_c('b-btn', {
    attrs: {
      "variant": "danger"
    },
    on: {
      "click": _vm.deleteSelectedMissionSlots
    }
  }, [_c('i', {
    staticClass: "fa fa-trash",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.delete.mission.slot.selection')) + "\n        ")])], 1), _vm._v(" "), _c('b-btn', {
    attrs: {
      "variant": "secondary"
    },
    on: {
      "click": _vm.clearMissionSlotSelection
    }
  }, [_c('i', {
    staticClass: "fa fa-times-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.clear.selection')) + "\n      ")])], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.hasMissionAnyRequiredDLCs) ? _c('br') : _vm._e(), _vm._v(" "), (_vm.hasMissionAnyRequiredDLCs) ? _c('div', {
    staticClass: "text-center small text-muted"
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/aow.png",
      "width": "12px",
      "alt": "Art of War"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.aow')) + " | \n    "), _c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/apex.png",
      "width": "12px",
      "alt": "Apex"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.apex')) + " | \n    "), _c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/contact.png",
      "width": "12px",
      "alt": "Contact"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.contact')) + " | \n    "), _c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/csla.png",
      "width": "12px",
      "alt": "CSLA Iron Curtain"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.csla')) + " | \n    "), _c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/ef.png",
      "width": "12px",
      "alt": "Expeditionary Forces"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.ef')) + " | \n    "), _c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/gm.png",
      "width": "12px",
      "alt": "Global Mobilization"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.gm')) + " | \n    "), _c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/helicopters.png",
      "width": "12px",
      "alt": "Helicopters"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.helicopters')) + " | \n    "), _c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/jets.png",
      "width": "12px",
      "alt": "Jets"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.jets')) + " | \n    "), _c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/karts.png",
      "width": "12px",
      "alt": "Karts"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.karts')) + " | \n    "), _c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/laws-of-war.png",
      "width": "12px",
      "alt": "Laws of War"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.laws-of-war')) + " | \n    "), _c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/marksmen.png",
      "width": "12px",
      "alt": "Marksmen"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.marksmen')) + " |\n    "), _c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/rf.png",
      "width": "12px",
      "alt": "Reaction Forces"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.rf')) + " | \n    "), _c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/tac-ops.png",
      "width": "12px",
      "alt": "Tac-Ops"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.tac-ops')) + " | \n    "), _c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/tanks.png",
      "width": "12px",
      "alt": "Tanks"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.tanks')) + " | \n    "), _c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/vn.png",
      "width": "12px",
      "alt": "S.O.G. Prairie Fire"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.vn')) + "\n  ")]) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ee0770bc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/missions/MissionSlotlist.vue
// module id = 578
// module chunks = 0